<template>
  <div class="gallery-converter-view app-page-wrapper absolute" data-cy="gallery-converter-view">
    <gallery-menu />

    <header
      class="gallery-converter-view-header w-full safe-area text-28 text-texts-standard-default flex justify-between items-center"
    >
      <aside class="flex items-center">
        <app-icon class="ml-1" icon-name="info-rounded" />
        <p class="text-left ml-5">
          {{ $t('gallery.convertorInfo') }}
        </p>
      </aside>
    </header>

    <main class="gallery-converter-view-main flexing w-full">
      <gallery-converter
        v-for="(converter, index) in converters"
        :key="index"
        :converter="converter"
        :process="getProcessByType(converter.conversion_type)"
      />
    </main>
  </div>
</template>

<script lang="ts">
import { pathImages } from '@/globalVariables'
import { defineComponent } from 'vue'
import GalleryMenu from '@/components/Gallery/GalleryMenu.vue'
import GalleryConverter from '@/components/Gallery/GalleryConverter.vue'
import { ConversionType } from '@/interfaces/gallery/enums'
import type { ConversionProcess } from '@/interfaces/gallery/Converter'
import { mapState, mapActions } from 'pinia'
import { useGalleryConverterStore } from '@/store/pinia/gallery/converterStore'

interface ComponentData {
  pathImages: typeof pathImages
  ConversionType: typeof ConversionType
}

export default defineComponent({
  name: 'GalleryConverterView',

  components: {
    GalleryMenu,
    GalleryConverter,
  },

  data(): ComponentData {
    return {
      pathImages,
      ConversionType
    }
  },

  computed: {
    ...mapState(useGalleryConverterStore, [
      'converters',
      'processes',
    ])
  },

  created(): void {
    this.loadConverterData()
  },

  methods: {
    ...mapActions(useGalleryConverterStore, ['loadConverterData']),

    getProcessByType(type: ConversionType): ConversionProcess | null {
      return (
        this.processes?.find((process: ConversionProcess): boolean => process.conversion_type === type) || null
      )
    },
  },
})
</script>

<style lang="scss" scoped>
.gallery-converter-view {
  @include background(url('#{$path-gallery}BG_FULLSCREEN.avif?v1'), cover);
  &-header {
    padding: 1.5rem 2.5rem;
  }
}
</style>
